import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

interface CarouselIndicatorIconProps {
  isActive?: boolean;
}

export const CarouselIndicatorIcon = forwardRef<
  SVGSVGElement,
  IconClientSVGProps & CarouselIndicatorIconProps
>(({ label, isActive, width, ...props }, ref) => {
  return (
    <Icon label={label}>
      <svg
        ref={ref}
        {...props}
        width={width}
        viewBox={`0 0 ${width} 4`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="1"
          width={width}
          height="4"
          fill={
            isActive
              ? "var(--surface-decision-default)"
              : "var(--surface-base-overlay-light-grey)"
          }
          fillOpacity={isActive ? "1" : "0.6"}
        />
      </svg>
    </Icon>
  );
});

CarouselIndicatorIcon.displayName = "PauseIcon";
